import { type FC } from "react";
import { COLOR_GREY_9, COLOR_GREY_8 } from "shared/theme/colors";
import { StyledContainer, StyledRectangleContainer } from "./styled";

const TextBlockPlaceholder: FC = () => {
  return (
    <StyledContainer>
      <StyledRectangleContainer width={18} height={3} bgColor={COLOR_GREY_9} />
      <StyledRectangleContainer width={75} height={2} bgColor={COLOR_GREY_8} />
      <StyledRectangleContainer width={68} height={2} bgColor={COLOR_GREY_8} />
      <StyledRectangleContainer width={43} height={2} bgColor={COLOR_GREY_8} />
    </StyledContainer>
  );
};

export default TextBlockPlaceholder;
